import { create } from 'zustand';
import type { DashboardStats } from '@/types/dashboard';

interface DashboardState extends DashboardStats {
  isLoaded: boolean;
  updateStats: (stats: DashboardStats) => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  total_active: undefined,
  in_reaction: undefined,
  en_route: undefined,
  avg_speed: undefined,
  no_signal: undefined,
  high_risk: undefined,
  isLoaded: false,

  updateStats: (stats) => {
    const enRoute =
      stats.en_route ??
      (stats.total_active != null && stats.in_reaction != null
        ? stats.total_active - stats.in_reaction
        : undefined);

    set({
      total_active: stats.total_active,
      in_reaction: stats.in_reaction,
      en_route: enRoute,
      avg_speed: stats.avg_speed,
      no_signal: stats.no_signal ?? stats.risk_stats?.no_signal ?? stats.sin_senal,
      high_risk: stats.high_risk ?? stats.risk_stats?.high_risk ?? stats.riesgo_alto,
      isLoaded: true,
    });
  },
}));
